import React from "react";
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel'
import FormRichText from '../../../library/form/components/FormRichText'
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle'
import FormSH from '../../../library/form/components/FormSH';
import { UiGridColOne, UiCol } from "../../../library/layout/Index";

const ProfileTermsEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            contentStyle={{ height: '280px', width: '700px' }}
            
            formTitle={<FormTitle formObject={formObject} value='Payment Terms' />}
            formObject={formObject} >
            <UiGridColOne>
                <UiCol>
                    <ul>
                        <li>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentMode" }} value="Payment Mode" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" autofocus className="uiInput"
                                    action={{ InputType: "ac", paramName: "paymentMode", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />

                                <FormSH formObject={formObject} rowKey=""
                                    action={{ actionId: "new", paramName: "paymentMode", actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                ></FormSH>
                            </div>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                                    action={{ InputType: "ac", paramName: "currency", acMethod: "CurrencyName"}}
                                />
                            </div>
                        </li>
                        <li>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "advPerc" }} value="Advance %" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "advPerc" }} />
                            </div>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "creditLimit" }} value="Credit Limit" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "creditLimit" }} />
                            </div>
                        </li>
                        <li>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "againstDelPerc" }} value="Against Del %" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "againstDelPerc" }} />
                            </div>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "creditDays" }} value="Credit Days" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "creditDays" }} />
                            </div>
                        </li>
                        <li>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                </span>
                            </div>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "graceDays" }} value="Grace Days" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "graceDays" }} />
                            </div>
                        </li>
                        <li>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "terms" }} value="Payment Terms" />
                                </span>
                                <FormRichText formObject={formObject} rowKey="" rows="5" cols="60" className=""
                                    action={{ paramName: "terms" }} />
                            </div>
                        </li>
                    </ul>
                </UiCol>
            </UiGridColOne>
        </FormDialog>
    )
}

export default withView(ProfileTermsEditor, "proTerms", "proTerms")
